import { cn } from "@/utils";
import type { SVGProps } from "react";

export default function TwentyOneIcon({
  className,
  ...props
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("size-6", className)}
      {...props}
    >
      <path
        d="M16 18V9H15C14.4477 9 14 8.55228 14 8C14 7.44772 14.4477 7 15 7H17L17.1025 7.00488C17.6067 7.05621 18 7.48232 18 8V18C18 18.5523 17.5523 19 17 19C16.4477 19 16 18.5523 16 18Z"
        fill="currentColor"
      />
      <path
        d="M19 17C19.5523 17 20 17.4477 20 18C20 18.5523 19.5523 19 19 19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H19Z"
        fill="currentColor"
      />
      <path
        d="M10 10.25C9.99997 9.61476 9.68061 9.20975 9.35449 9.06934C9.07453 8.94887 8.49161 8.90535 7.69531 9.67676C7.29871 10.0607 6.66643 10.0506 6.28223 9.6543C5.89795 9.25762 5.90801 8.62451 6.30469 8.24023C7.50819 7.07447 8.92549 6.70716 10.1455 7.23242C11.3194 7.73782 12 8.94783 12 10.25C12 11.4149 11.6917 12.2743 11.1777 12.9658C10.7064 13.6 10.0691 14.0628 9.62793 14.4189C9.15115 14.8039 8.77448 15.1502 8.49609 15.6445C8.31181 15.9718 8.15301 16.4016 8.06738 17H11C11.5523 17 12 17.4477 12 18C12 18.5523 11.5523 19 11 19H7C6.44772 19 6 18.5523 6 18C6 16.5745 6.2778 15.5097 6.75391 14.6641C7.22547 13.8266 7.84902 13.2846 8.37207 12.8623C8.93077 12.4113 9.29368 12.1473 9.57227 11.7725C9.80831 11.4548 10 11.0225 10 10.25Z"
        fill="currentColor"
      />
      <path
        d="M24 13C24 6.92487 19.0751 2 13 2C6.92487 2 2 6.92487 2 13C2 19.0751 6.92487 24 13 24C19.0751 24 24 19.0751 24 13ZM26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z"
        fill="currentColor"
      />
    </svg>
  );
}
